<template>
  <svg
    class="gp-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 283"
    aria-hidden="true"
    focusable="false"
  >
    <path fill="#ea4335" d="M119.553 134.916L1.06 259.061a32.14 32.14 0 0 0 47.062 19.071l133.327-75.934z"/>
    <path fill="#fbbc04" d="M239.37 113.814L181.715 80.79l-64.898 56.95l65.162 64.28l57.216-32.67a31.345 31.345 0 0 0 0-55.537z"/>
    <path fill="#4285f4" d="M1.06 23.487A30.6 30.6 0 0 0 0 31.61v219.327a32.3 32.3 0 0 0 1.06 8.124l122.555-120.966z"/>
    <path fill="#34a853" d="m120.436 141.274l61.278-60.483L48.564 4.503A32.85 32.85 0 0 0 32.051 0C17.644-.028 4.978 9.534 1.06 23.399z"/>
  </svg>
</template>

<style scoped>
.gp-icon {
  height: 1em;
  width: auto;
  display: inline-block;
  vertical-align: -0.12em;
}
</style>
